/** Человеко-время посетителей в очереди (Алексей 22.10, #1840): до часа — «N чел·мин»,
 *  от 60 — человеко-часы с одним знаком: «48.2 чел·ч». */
export function fmtPersonTime(personMinutes: number): string {
  const pm = Math.round(personMinutes);
  if (pm < 60) return `${pm} чел·мин`;
  return `${Number((pm / 60).toFixed(1))} чел·ч`;
}

/** Обратно в минуты: «975 чел·мин», «16.3 чел·ч», «16,3 чел·ч»; null — не похоже. */
export function parsePersonTime(text: string): number | null {
  const m = /^(\d+(?:[.,]\d+)?)\s*чел·(мин|ч)$/u.exec(text.trim().replace(/ /g, ' '));
  if (!m) return null;
  const n = Number(m[1].replace(',', '.'));
  return m[2] === 'ч' ? Math.round(n * 60) : Math.round(n);
}
